import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-plan-card',
    imports: [ProgressSpinnerModule, ButtonModule],
    templateUrl: './plan-card.component.html',
    styleUrl: './plan-card.component.scss',
    host: {
        '[class.current]': 'isCurrent()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanCardComponent {
    public readonly name = input<string>('Starter');
    public readonly price = input<number>(5);
    public readonly period = input<string>('mo');
    public readonly benefits = input<string[]>([]);
    public readonly isActionButtonVisible = input<boolean>(true);
    public readonly isActionButtonLoading = input<boolean>(false);
    public readonly actionButtonLabel = input<string>('Buy');
    public readonly isCurrent = input<boolean>(false);

    public readonly actionButtonClick = output<MouseEvent>();
}
